<template>
  <div>
     <b-row class="mb-4">

       <b-col md="11">
        <div class="form-group form-actions float-left pb-2">
          <b-button
          :disabled="isGenerating"
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="refreshPPT"
          >
            Generate Report
          </b-button>
        </div>
      </b-col>
      <b-col md="1" >
              <span class="icon-small">
               <i 
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i>
                </span>
            </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          style="font-size: 8.5pt;"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        ></b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";

export default {
  data: () => {
    return {
      isGenerating: false,
      fields: [
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true,
        },
        {
          key: "UserName",
          label: "Planner",
          sortable: true,
        },
        {
          key: "Month",
          label: "Month",
          sortable: true,
        },
        {
          key: "Year",
          label: "Year",
          sortable: true,
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true,
        },
        {
          key: "SeminarList",
          label: "Dates",
          sortable: true,
        },
      ],
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      //   current_month: this.filter_month,
      //   current_year: this.filter_year
    };
  },
  components: {
    cTable,
  },
  async created() {
    this.refreshPPT();
    //await this.$store.dispatch("territory/GetPPTEntries");
  },
  computed: {
    totalRows: function () {
      return this.$store.state.territory.ppt_entries.length;
      //return 4;
    },
    totalObjects: function () {
      return this.$store.state.territory.ppt_entries;
      //return 4;
    },
    totalRowsFiltered: function () {
      return this.filteredObjects.length;
    },
    isNavVisible: function () {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "globals"]),
  },
  props: {
    filter_year: String,
    filter_month: String,
    filter_pp: Number,
  },
  methods: {
    async refreshPPT()
    {
      this.isGenerating = true;
      var _pptOp =
    {
      Month: this.$store.state.globals.ppt_month,
      Year: this.$store.state.globals.ppt_year,
      //UserProfileID : -1
      UserProfileID : this.$store.state.globals.default_pp
    }
    await this.$store.dispatch("territory/GetFilteredPPTEntries", _pptOp);
    this.filterList();
    },
     my_download() {
       var _op =
       {
     "Month": this.$store.state.globals.ppt_month,
"Year": this.$store.state.globals.ppt_year,
"UserProfileID": this.$store.state.globals.default_pp,
     "TerritoryName": this.$store.state.globals.default_search_string.toLowerCase(),
           }
       //console.log(_op);
       //console.log(this.$store.state.globals.default_pp);
       

this.$store
        .dispatch("seminar/DownloadPPTReport", _op)
        .then(response => (
          window.open("http://rm_api.revolutionterritorymanager.com/Output/" + response.data["PPTReportDownloadResult"], "_blank") 
        )
        );
    },
    filterList: function () {
      this.filteredObjects = this.$store.state.territory.ppt_entries.filter(
        (ppt) =>
          ppt.TerritoryName.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
          ppt.UserName.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 

      );
      this.isGenerating = false;
    },
  },
  watch: {
    "$store.state.globals.ppt_year": function (newValue, oldValue) {
    //   var _pptOp =
    // {
    //   Month: this.$store.state.globals.ppt_month,
    //   Year: this.$store.state.globals.ppt_year,
    //   //UserProfileID : -1
    //   UserProfileID : this.$store.state.n_user.n_current_user.UserProfileID
    // }
    //   this.filterList();
    //this.refreshPPT();
    },
    "$store.state.globals.ppt_month": function (newValue, oldValue) {
      //this.filterList();
      //this.refreshPPT();
    },
    "$store.state.globals.default_pp": function (newValue, oldValue) {
      //this.filterList();
      //this.refreshPPT();
    },
    "$store.state.globals.default_search_string": function (
      newValue,
      oldValue
    ) {
      this.filterList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
